import {Component} from "react";
import ApiService from "../ApiService";
import CreateSiteForm from "../../models/CreateSiteForm";
import DispatchProps from "../../utils/DispatchProps";
import {MessageBarType} from "office-ui-fabric-react";
import Actions from "../../redux/Actions";
import * as H from "history";
import { ValidationUtils } from "../../models/Validation";


interface BaseCreateSitePageProps {
    tenantId: string;
    schoolCode: string;
    
    history: H.History;
    apiService: ApiService;
}

interface BaseCreateSitePageState {
    saveButtonDisabled: boolean;
    form?: CreateSiteForm;
}

export default abstract class BaseCreateSitePage<TP extends BaseCreateSitePageProps & DispatchProps,TS extends BaseCreateSitePageState> extends Component<TP,TS> {
    
    protected constructor(props: TP) {
        super(props);
    }

    protected submitForm = async () => {

        if(this.state.form == undefined){
            return;
        }

        if(this.props.tenantId || this.props.schoolCode)
        {
            this.state.form.tenantId = this.props.tenantId;
            this.state.form.schoolCode= this.props.schoolCode;
        }

        const validationResult = ValidationUtils.validateCreateSiteForm(this.state.form!);
        if (validationResult.isValid)
        {
            
            try
            {
                this.setState({saveButtonDisabled: true});
                await this.props.apiService.postCreateSiteForm(this.state.form!);
                this.props.dispatch(Actions.showMessageBar("Site queued for creation, please allow up to 1 hour for it to appear on the megamenu.",MessageBarType.success));
                this.props.history.push(`/manage/${this.props.tenantId}/${this.props.schoolCode}`);
            }
            catch(e)
            {
                this.props.dispatch(Actions.showMessageBar(`Create site request failed: ${e.message}`,MessageBarType.error));
            }
            finally
            {
                this.setState({ saveButtonDisabled: false });
            }

        }
        else
        {
            this.props.dispatch(Actions.showMessageBar(validationResult.toString(),MessageBarType.error));
        }
    };
}